import React, { Component } from "react";

import BackWithSearch from "../../Mobile/Elements/BackWithSearch";
import Meta from "../../helpers/meta";
// import PaymentList from "./PaymentList";
import { Redirect } from "react-router";
import { checkConfirmCart } from "../../../services/confirmCart/actions";
import { saveAddress, getAddresses } from "../../../services/addresses/actions";
import { updateUserInfo } from "../../../services/user/actions";
import { connect } from "react-redux";
import { placeOrder } from "../../../services/checkout/actions";
import Nav from "../Nav";
import Footer from "../Footer";
import { formatPrice } from "../../helpers/formatPrice";
import SimpleReactValidator from "simple-react-validator";
import PaypalExpressBtn from "react-paypal-express-checkout";

import { GET_ALL_PAYMENT_GATEWAYS_URL } from "../../../configs/index";
import axios from "axios";
// import Ink from "react-ink";

// import DelayLink from "../../helpers/delayLink";

import { PRODUCT_IMAGE_URL, DEFAULT_IMG  } from "../../../configs/index";

class Checkout extends Component {
	static contextTypes = {
		router: () => null,
	};
	constructor(props){
		super(props);
		this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            messages: {
				required: "This is a required field.",
				accepted: "By clicking to accept Terms and Condition",
				string: "Please enter the valid name",
				email: "Please enter a valid email",
				regex: "Please enter a phone number in this format: 12345678",
				min: "This field must be at least 8 characters long"
			},
        });
		
		 this.state = {
			loading: true,
			name : "",
			address :"",
			phone :"",
			address2 :"",
			// city :"",
			// country :"",
			province :"",
			postalcode : "",
			id : "",
			email : "",
			addressDiv : "is-active",
			paymentDiv: "",
			resultdata : [],
			paymentGateway : 0,
			paypalSandboxKey : 'AYIdimFR3mAYJKFtiVnYh-rORQKKDCs8og_kH-nrk-zWaLCWqfR_awO7_veFVww9sxOaj6Y4o4_NYn4I',
			paypalProductionKey : 'AYIdimFR3mAYJKFtiVnYh-rORQKKDCs8og_kH-nrk-zWaLCWqfR_awO7_veFVww9sxOaj6Y4o4_NYn4I',
			paypalSandboxActive : 1,
			couponAmount : 0,
			couponpercentage : 0,
			showHideClass : '',
			loader : false,
			hitpayStatus : false,
			hitpayMsg : '',

		}
	}
	
	
	cartTotalShowHide = () =>{
		if(this.state.showHideClass === "show"){
			this.setState({showHideClass : ''});
		}else{
			this.setState({showHideClass : 'show'});
		}
		
	}
	handleAddress = (event) => {
        event.preventDefault();
		if (this.validator.fieldValid("name") && this.validator.fieldValid("address")
			&& this.validator.fieldValid("phone")
			// && this.validator.fieldValid("city")
			// && this.validator.fieldValid("country")
			// && this.validator.fieldValid("province")
			&& this.validator.fieldValid("postalcode")) {
            // this.setState({ loading: true });
			// console.log(this.state);
			
            this.props.saveAddress(              
                this.state.id,
				this.state.name,
				this.state.phone,
				this.state.email,
				this.state.address,
				this.state.address2,
				this.state.city,
				this.state.province,
				this.state.postalcode,
				this.state.country,
                              
            );
			this.props.updateUserInfo(this.state.id);
			 this.setState({ addressDiv : '', paymentDiv: "is-active" });
			// console.log(this.props.user);
        } else {
            console.log("validation failed");
            this.validator.showMessages();
        }
    };
	
	componentDidMount() {
		if (this.props.cartProducts.length) {
			document.getElementsByTagName("body")[0].classList.add("bg-grey-light");
		}
		const {user} = this.props;
		console.log(user);
		if(user.success == 1){
			// console.log(user.profile);
			// console.log(user.profile.id);
			 this.setState({ 
				id: user.profile.id,
				email: user.profile.email_id, 			 
				name: user.profile.firstname, 
				phone: (!user.profile.phone_no) ? '' : user.profile.phone_no, 			 
				address: (!user.profile.address_line_1) ? '' : user.profile.address_line_1,
				address2: (!user.profile.address_line_2) ? '' : user.profile.address_line_2,					
				city: (!user.profile.city) ? '' : user.profile.city,
				country: (!user.profile.country) ? '' : user.profile.country, 			 
				province: (!user.profile.state) ? '' : user.profile.state, 
				postalcode: (!user.profile.zipcode) ? '' : user.profile.zipcode, 			 
			 });
		}
		
		axios.get(GET_ALL_PAYMENT_GATEWAYS_URL).then((response) => {
			// console.log(response);
			// console.log(response.data);
			// console.log(response.data.success);
			this.setState({ loading: false });
			if(response.data.success == 1){		
if(response.data.gateways.length){
				response.data.gateways.map((item, index) => {	
				// console.log(item);
					if(item.gateway_name == "PayPal"){
						// console.log(item.is_sandbox);
						this.setState({ paymentGateway : 1 });
						this.setState({ paypalSandboxKey : item.gateway_credential_1 });
						this.setState({ paypalProductionKey : item.gateway_credential_2 });
						this.setState({ paypalSandboxActive : item.is_sandbox });
					}
				});
}
				this.setState({ resultdata: response.data.products });		
				this.setState({ paymentGateway : 1 });
			}else{				
				this.setState({ resultdata: [] });
			}
		})
		.catch(function(error) {
			console.log(error);
		});
		
		if(localStorage.getItem("appliedCoupon")){
			let couponAmt  = formatPrice((this.props.cartTotal.totalPrice * parseFloat(localStorage.getItem("appliedCoupon"))) / 100);
			this.setState({couponAmount : couponAmt});
			this.setState({couponpercentage : localStorage.getItem("appliedCoupon")});
		}
		
	}

	cash_on_delivery = () => {
		// alert('Suucess cash on delivery');
		const payment_token = 2;
		const method = "CashOnDelivery";
		this.__placeOrder(payment_token, method);
	}
	__placeOrder = (payment_token, method) => {
		const { user, cartProducts, cartTotal } = this.props;
		this.setState({loader : true});
		if (user.success) {
			this.props.placeOrder("",
									this.state.name,
									this.state.id,
									this.state.phone,
									this.state.email,
									this.state.address,
									this.state.city,
									this.state.province,
									this.state.country,
									this.state.postalcode,
									this._getCalculation(),
									this.state.couponAmount,
									this.state.couponpercentage,
									0,
									0,
									payment_token,
									cartProducts);
		}
		
	};

/* Paypal */
	onSuccess = (payment) => {
		const payment_token = 1;
		const method = "PAYPAL";
		this.__placeOrder(payment_token, method);
	};

	onCancel = (data) => {
		console.log("Paypal Payment Canceled");
	};

	onError = (err) => {
		console.log("Error!");
	};
	/* END Paypal */
	
	
	_getCalculation(){
		const {cartTotal} = this.props;
		let finalPrice = 0;
		// console.log(localStorage.getItem("appliedCoupon"));
		if(localStorage.getItem("appliedCoupon")){
			let couponAmount  = formatPrice((cartTotal.totalPrice * parseFloat(localStorage.getItem("appliedCoupon"))) / 100);		
			finalPrice = formatPrice(cartTotal.totalPrice) - formatPrice(cartTotal.discountPrice) - couponAmount;
			
		}else{
			finalPrice = formatPrice(cartTotal.totalPrice) - formatPrice(cartTotal.discountPrice);
		}
		
		return formatPrice(finalPrice);
	}
	
	handleInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };
	componentWillReceiveProps(nextProps) {
		// console.log(nextProps.checkout);
		// console.log( this.props.checkout);
		if (nextProps.checkout !== this.props.checkout) {
			console.log('redirect');
			// console.log(nextProps.checkout.booking_id);
			//redirect to running order page
			this.context.router.history.push("/running-order/" + nextProps.checkout.booking_id);
			// this.context.router.history.push("/my-orders");
		}
	}
	componentWillUnmount() {
		document.getElementsByTagName("body")[0].classList.remove("bg-grey-light");
		this.setState = (state,callback)=>{
			return;
		};
	}
	
	/* Hitpay */
	__handleHitPay = () => {
		let self = this;
		
		let totalAmount = self._getCalculation();
		const currency = 'SGD';
		const userEmail = this.state.email;
		const orderNumber = 'SPA123';
		const hitPayStoreID = '';
		
		const sandboxApi_URL = "https://api.sandbox.hit-pay.com/v1/payment-requests/";
		
		const productionApi_URL = "https://api.hit-pay.com/v1/payment-requests/";
		
		//const API_KEY = '7a582072f38e99b1bc8893dc91427c966dea26aa1769807f022610fba8643c8c';
		const API_KEY = 'b2eb869315f769f813564dfcf4129729c2e31f677e63100376aadb4c85f359aa';
		
		var myWindow;
					
		axios.defaults.headers.common = {
			'X-BUSINESS-API-KEY' : API_KEY,
			'Content-Type' : 'application/x-www-form-urlencoded',
			'X-Requested-With' : 'XMLHttpRequest',
			'Access-Control-Allow-Origin' : '*',
        };
		axios.post(productionApi_URL, {	
				'email' : userEmail,
				'currency' : currency,
				'amount' : totalAmount
		}).then((response) => {
			// console.log(response);		
			console.log(response.data);		
			// console.log(response.data.url);		
			// console.log(response.data.id);		
			myWindow = window.open(response.data.url, "Hitpay", "width=1000, height=600");
			 
		var myInterval = setInterval(() => {	 
			axios.defaults.headers.common = {
				'X-BUSINESS-API-KEY' : API_KEY,
				'Content-Type' : 'application/x-www-form-urlencoded',
				'X-Requested-With' : 'XMLHttpRequest',
				'Access-Control-Allow-Origin' : '*',
			};
			axios.get(productionApi_URL + response.data.id , {	
					
			}).then((response) => {
				console.log(response.data);		
				console.log(response.data.status);		
				if(response.data.status == 'completed'){
					myWindow.close();
					this.setState({hitpayStatus : true, hitpayMsg:"Payment Succeded"});
					clearInterval(myInterval);
					this.__placeOrder(12, 12);
					
				}		
			})
			.catch(function(error) {
				console.log(error);
			});
		}, 5000);
		})
		.catch(function(error) {
			console.log(error);
		});
			
			
	};
	/* END Hitpay */
	

	render() {
		
		const { cartTotal, cartProducts, user } = this.props;
		const client = {
			sandbox: this.state.paypalSandboxKey,
			production: this.state.paypalProductionKey,
		};
		/*const client = {
			sandbox: "Ac0HMj2-4wazJU-fs1FcjG7Z6Fe7KYQUqa6e1v-_8G-AR4OEkmUE-ZdekDmiiS-XeMA1JL-GfmzlCBsh",
			production: "Ac0HMj2-4wazJU-fs1FcjG7Z6Fe7KYQUqa6e1v-_8G-AR4OEkmUE-ZdekDmiiS-XeMA1JL-GfmzlCBsh",
		};	
		*/
		if (!this.props.cartProducts.length) {
			// no items in cart after checkout goto cart page
			return <Redirect to={"/cart"} />;
		}

		//TODO:
		//check if the referrer is cart page, if not then redirect to cart
		if (!this.props.confirmCart) {
			return <Redirect to={"/cart"} />;
		}
		if (this.state.loading) {
			return (
				<div className="height-100 overlay-loading" id="login-loader">
					<div>
						<img src="/assets/img/loading-food.gif" alt="Please wait" />
					</div>
				</div>
			);				
		}
		
		return (
			<React.Fragment>
				
				<Meta />
				<Nav />
				{(this.state.loader) ?
				<div className="section-loading">
					<div>
						<img src="/assets/img/loading-food.gif" alt={localStorage.getItem("pleaseWaitText")} />
					</div>
				</div>
				: '' }
				<div className="checkout">
					
					
	<div className="checkout__form"> 
        <div className="pages">
	{/*page1 - start*/}
					<div className={"page page--1 " + this.state.addressDiv }>
					<form onSubmit={this.handleAddress} id="loginForm">		
					<div className="row">
								<div className="col-md-8">
						<header className="header">
						<h3 className="main-heading">Shipping address</h3>
						</header>
						<p className="microcopy">Please tell us where to ship your order.</p>
				
				
						<div className="f">
						<div className="input">
							<label htmlFor="name" className="input__label">Your full name <span className="required">(required)</span></label>
							<input  id="name" name="name" type="text" className="input__input" onChange={this.handleInputChange} value={this.state.name} />
							<div className="error">{this.validator.message("name", this.state.name, "required")}</div>
						</div>
						<div className="f40">
						<div className="input">
							<label htmlFor="phone" className="input__label">Phone <span className="required">(required)</span></label>
							<input id="phone" name="phone" type="text" className="input__input" onChange={this.handleInputChange} value={this.state.phone} />
							<div className="error">{this.validator.message("phone", this.state.phone, [
													"required",
													{ regex: ["^\\d{1,14}$"] },
													{ min: ["8"] }
												])}</div>
							</div>
						</div>
						<div className="f60">
							<div className="input">
							<label htmlFor="address" className="input__label">Address <span className="required">(required)</span></label>
							<input id="address" name="address" type="text" className="input__input" onChange={this.handleInputChange} value={this.state.address} />
							<div className="error">{this.validator.message("address", this.state.address, "required")}</div>
							</div>
						</div>
						
						
						<div className="input">
							<label htmlFor="address2" className="input__label">Address <span className="optional">(optional)</span></label>
							<input id="address2" type="text" name="address2" className="input__input" onChange={this.handleInputChange} value={this.state.address2} />
						</div>
							
						<div className="f35">
							<div className="input">
								<label htmlFor="city" className="input__label">City <span className="optional">(optional)</span></label>
								<input id="city" name="city" type="text" className="input__input"  onChange={this.handleInputChange} value={this.state.city} />
								<div className="error">{this.validator.message("city", this.state.city, "required")}</div>
							</div>
						</div>
						<div className="f35">
							<div className="input">
							<label htmlFor="country" className="input__label">Country <span className="optional">(optional)</span></label>
							<input name="country" id="country" className="input__input"  onChange={this.handleInputChange} value={this.state.country} />
								<div className="error">{this.validator.message("country", this.state.country, "required")}</div>				  
							</div>
						</div>
					{/* <div className="f35">
							<div className="input">
							<label htmlFor="province" className="input__label">Province <span className="required">(required)</span></label>
							<input name="province" id="province" className="input__input"  onChange={this.handleInputChange} value={this.state.province} />    
								<div className="error">{this.validator.message("province", this.state.province, "required")}</div>				  
							</div>
						</div> */}
						<div className="f30">
							<div className="input">
							<label htmlFor="postalcode" className="input__label">Postal code <span className="required">(required)</span></label>
							<input id="postalcode" name="postalcode" type="text" className="input__input"  onChange={this.handleInputChange} value={this.state.postalcode} />
							<div className="error">{this.validator.message("postalcode", this.state.postalcode, ["required" ])}</div>	
							</div>
						</div>
						</div>
						
				
				</div>
								<div className="col-md-4">
								<div className="checkout__summary">   
									
								
									<div  className={'f checkout-summary-detail ' + this.state.showHideClass} >
									<header className="header">
									<h3 className="main-heading">Order summary</h3>
									</header>
									<p className="microcopy">A summary of your total order.</p>
									<table className="pricing">
										<tbody>
									{cartProducts.map((product, index) => (	
										<tr key={index}>							  
											<td><img src={PRODUCT_IMAGE_URL + product.product_image} alt={product.product_name} onError={(e)=>{e.target.src=DEFAULT_IMG}} className="mCS_img_loaded" width="50" height="50" /></td>
											<td className="pricing__label">{product.product_name} x {product.quantity}</td>
											<td className="pricing__price">S${formatPrice(product.finalprice * product.quantity)}</td>
										</tr>	
									))}
										</tbody>
									</table>
								
									<table className="pricing">
										<tbody>
										{/* <tr>
											<td className="pricing__label">Discount</td>
											<td className="pricing__price">-S${formatPrice(cartTotal.discountPrice)}</td>
										</tr>
										<tr>
											<td className="pricing__label">Subtotal</td>
											<td className="pricing__price">S${formatPrice(cartTotal.totalPrice - cartTotal.discountPrice )}</td>
										</tr>
										*/}
										
										{(localStorage.getItem("appliedCoupon"))?
											<tr>
												<td className="pricing__label">Coupon</td>
												<td className="pricing__price">-S${formatPrice((cartTotal.totalPrice * parseFloat(localStorage.getItem("appliedCoupon"))) / 100)}</td>
											</tr>
										:  '' }
										{/*<tr>
											<td className="pricing__label">Shipping</td>
											<td className="pricing__price">$0.00</td>
										</tr> */}
										
										</tbody>
										<tfoot>
										<tr className="pricing__total">
											<td className="pricing__label">Total</td>
											<td className="pricing__price"><span className="currency">S$</span> <b>{this._getCalculation()}</b></td>
										</tr>
										
										</tfoot>
									</table>
									</div>
									<div className="form__footer">
									<div className="checkout-total">
									 <div className="total-label">Total Payable
									
									 <div className="showdetail-btn"  onClick={this.cartTotalShowHide} >Show Details</div>
									 </div>
                                     <div className="price-total">S${this._getCalculation()}</div>
								</div>	
						<button className="btn btn-continue js-goto" data-page="2">
							<span className="btn__label">Proceed to Pay</span>
							<svg className="btn__loader" viewBox="25 25 50 50">
							<circle cx="50" cy="50" r="20" fill="none" className="path"></circle>
							</svg>
						</button>
						</div>
								</div>
								
								</div>

							</div>
							</form>
					</div>
		
		{/*page1 - end*/}
		
		{/*page2 - Start*/}		
		<div className={"page page--2 " + this.state.paymentDiv }>
    
            <header className="header">
              <h3 className="main-heading">Payment Method</h3>
            </header>
            <p className="microcopy">Select the payment method you would like to use.</p>
			{/* <div className="card cod">
				<div className="card-body">
			
			
				<button className="btn btn-primary cod-btn" onClick = { e => this.cash_on_delivery()}> Cash On Delivery </button>
				
				</div>
				
				
			</div> */}
			<div className="card paynow">
			<div className="card-body">
				<h4 className="note-txt">Please Whatsapp Us 96274977  after your payment.</h4>
					<button className="btn btn-success cod-btn" onClick={() => this.__handleHitPay()}> PayNow  <img className="paynow-icon" width="70px" src="/assets/img/various/paynow-logo.png"/> </button>
						{(this.state.hitpayMsg)? <>{this.state.hitpayMsg}</> : ''}
				</div>
			</div>
			<div className="card paypal">
            <div className="card-body">
			<div className="payment_type_title">

<h5 className="s_title">Credit / Debit Payment </h5>
<div className="payment_imgwrapper">
	<img src="/assets/img/payment-gateway.jpg" alt="payment-gateway" />
</div>
</div>
			{(this.state.paymentGateway === 1) ?
			
				<div className="paymentGatewayBlock paypal-payment" id={(this.state.paypalSandboxActive)}>
					<span className='paypal-subtext'>We accept Visa/ Master and AMEX Credit cards through Paypal Payment Gateway.  Kindly click below button and enter your email id as a guest and proceed.</span>
					  <PaypalExpressBtn
						env= {(parseInt(this.state.paypalSandboxActive) === 1) ? "sandbox" : "production"}
						client={client}
						currency="SGD"
						total={parseFloat(this._getCalculation())}
						shipping={1}
						onError={this.onError}
						onSuccess={this.onSuccess}
						onCancel={this.onCancel}
						style={{
							size: "responsive",
							color: "silver",
							shape: "rect",
						}}
					/>
				</div>
			: '' }
			</div>
			</div>
            <div className="hidden">
              <button className="btn btn--primary js-goto" data-page="2">                
                <span className="btn__label">Confirm to Pay</span>
                <svg className="btn__loader" viewBox="25 25 50 50">
                  <circle cx="50" cy="50" r="20" fill="none" className="path"></circle>
                </svg>
              </button>
            </div>
    
          </div>
		{/*page2 - end*/}
		
	
	
		</div>
		</div>
				 </div>
				 { <Footer /> }
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => ({
	total: state.total.total,
	user: state.user.user,
	addresses: state.addresses.addresses,
	cartProducts: state.cart.products,
	cartTotal: state.total.data,
	confirmCart: state.confirmCart.confirmCart,
	checkout: state.checkout.checkout,
});
export default connect(mapStateToProps, { checkConfirmCart, placeOrder, saveAddress, updateUserInfo })(Checkout);
